module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dr.Paul Young.b029ce14.jpg";